import { defineStyleConfig } from "@chakra-ui/react";

const Filters = defineStyleConfig({
  baseStyle: () => {
    return {};
  },
});

export default Filters;
